var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        [
          _c("b", [_vm._v("Domains")]),
          _c("v-spacer"),
          !_vm.creating
            ? _c(
                "v-btn",
                {
                  staticClass: "float-sm-right mt-2 mx-2",
                  attrs: { small: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("createReq")
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [
                    _vm._v("mdi-plus-box-outline"),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-text",
        [
          _c(
            "v-list",
            [
              _vm.showAlert
                ? _c("Alert", {
                    attrs: { text: "Domain updated", type: "success" },
                  })
                : _vm._e(),
              _vm._l(_vm.domainsData, function (domain, index) {
                return _c(
                  "v-list-item",
                  {
                    key: domain.id,
                    staticClass: "card-shadow border-radius-xl p-2",
                  },
                  [
                    _c(
                      "v-list-item-content",
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "8" } },
                              [
                                _c("EditableField", {
                                  staticClass: "mt-2",
                                  attrs: {
                                    value: domain.url,
                                    keyPath: `domainsData.${index}.url`,
                                    label: "URL",
                                    hideLabel: "",
                                    editing: _vm.editing[index],
                                  },
                                  on: { save: _vm.updateApiData },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "value",
                                        fn: function () {
                                          return [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "text-decoration-none",
                                                attrs: {
                                                  href: "https://" + domain.url,
                                                  target: "_blank",
                                                  rel: "noopener noreferrer",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-truncate",
                                                  },
                                                  [_vm._v(_vm._s(domain.url))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "4" } },
                              [
                                !_vm.editing[index]
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "float-sm-right mt-2 mx-2",
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteDomain(index)
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("mdi-trash-can-outline"),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "float-sm-right mt-2 mx-2",
                                    attrs: { icon: "", small: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleEdit(index)
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.editing[index]
                                            ? "mdi-content-save"
                                            : "mdi-pencil"
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm.editing[index]
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass:
                                          "btn-sm float-sm-right mt-2 mx-2",
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.cancelEdit(index)
                                          },
                                        },
                                      },
                                      [_vm._v(" Cancel ")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }